import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@lightspeed/flame/Text';

import { useMoney } from '~/renderer/hooks/.';

import type { Discount } from '~/renderer/store/receipt/types';

interface ReceiptItemDiscountProps {
  discount: Discount | undefined;
  lineNumber: number;
  lineDiscount: number;
}

const ReceiptItemDiscount: React.FunctionComponent<ReceiptItemDiscountProps> = ({
  lineNumber,
  discount,
  lineDiscount,
}) => {
  const { t } = useTranslation();
  const { money } = useMoney();

  if (!discount) return null;

  return (
    <Text
      lineHeight="normal"
      pt={1}
      size="small"
      color="gray-400"
      data-testid={`saleLine-${lineNumber}-discount`}
    >
      {t('receipt.discount')} {money(lineDiscount)}
    </Text>
  );
};

export { ReceiptItemDiscount };
